import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {

  //  获取场站安全管理枚举类
  getSafetyEnum() {
    return http.requestGet(apiPre + service.res + '/res/stationSafety/getSafetyEnum',{})
  },
  // 获取充电站信息
  getPage(params) {
    return http.requestPost(apiPre + service.res + '/res/stationSafety/getPage', params)
  },
  //  保存充电站安全管理信息
  saveOrUpdateSafety(params) {
    return http.requestPost(apiPre + service.res + '/res/stationSafety/saveOrUpdateSafety', params)
  },

  //删除充电站管理
  deleteSafety(params) {
    return http.requestPost(apiPre + service.res + '/res/stationSafety/deleteSafety', params)
  },

}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/safetyApi.js